const SET_SIZE = 7;
export default SET_SIZE;
